import { Space } from '@sravni/react-design-system';
import type { TagProps } from '@sravni/react-design-system/lib/Tag';
import { Tag } from '@sravni/react-design-system/lib/Tag';
import React from 'react';

interface IParamTagProps {
  value: string;
  onClick: () => void;
  isActive: boolean;
  background?: TagProps['background'];
}

export const FilterTag = ({ value, onClick, isActive, background }: IParamTagProps) => {
  return (
    <Tag
      active={isActive}
      size={36}
      onClick={onClick}
      background={background}
    >
      <Space
        size={4}
        align="center"
      >
        {value}
      </Space>
    </Tag>
  );
};
